export enum DialogReturnType {
  SAVE, CANCEL, DELETE, CONFIRM
}
